module.exports = __webpack_public_path__ + "static/media/Moonlight Graham Logo.ff7257fd.png";